var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "arrow_svg__icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M290.91 983.273a29.09 29.09 0 0 1-20.597-49.571L689.92 512 271.01 90.298a29.09 29.09 0 0 1 41.31-40.96L751.825 491.52a29.09 29.09 0 0 1 0 40.96L312.32 974.662a28.975 28.975 0 0 1-21.41 8.61z"
  })));
};

export default SvgArrow;